import {HttpService} from "./api/HttpService";

class PollPortalService {

    getPollAssignmentToken(nonce) {
        return new Promise((resolve, reject) => {
            try {
                HttpService.createWithoutAuthorization().get(`/pollPortal/auth/${nonce}`)
                    .then(result => resolve(result.data))
                    .catch(err => reject(err));
            } catch (error) {
                reject(error);
            }
        });
    }

    getPollAssignment() {
        return new Promise((resolve, reject) => {
            try {
                HttpService.createForPortal().get("/pollPortal")
                    .then(result => resolve(result.data))
                    .catch(err => reject(err));
            } catch (error) {
                reject(error);
            }
        });
    }

    submitPollResponse(pollDetails) {
        return new Promise((resolve, reject) => {
            HttpService.createForPortal().post('/pollPortal', pollDetails)
                .then(result => resolve(result.data))
                .catch(err => reject(err));
        });
    }
}

const svc = new PollPortalService();
export default svc;
